var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      false
        ? _c("NewComments", {
            attrs: { messageType: _vm.messageType, siteId: _vm.siteId },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "wl-content-container content-with-comments" },
        [
          [
            _c("div", { staticClass: "tab-row" }, [
              _c("ul", { staticClass: "tab-cls" }, [
                _c(
                  "li",
                  {
                    class: _vm.activeTab === "1" ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.activeChange("1")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("PAGE_EXCHANGE_TAB2")))]
                ),
                _c(
                  "li",
                  {
                    class: _vm.activeTab === "2" ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.activeChange("2")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("PAGE_EXCHANGE_TAB3")))]
                ),
              ]),
              _c("div", { staticClass: "btn" }, [
                _c(
                  "span",
                  {
                    class: [
                      "clear-filter",
                      _vm.cleanActive ? "clear-filter-active" : "",
                    ],
                    on: { click: _vm.clearAll },
                  },
                  [
                    _c("img", {
                      staticClass: "table-setting-icon",
                      attrs: { src: require("@/assets/img/icon-screen.svg") },
                    }),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("clear_filter")) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "bar-row" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green",
                      attrs: {
                        disabled:
                          !_vm.hasPermission("download") ||
                          (_vm.chooseable && !!_vm.multiChoose.mode),
                        icon: "el-icon-download",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleMultiSelect("download")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("BATCH_DOWNLOAD")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm.activeTab == 2 &&
                  !_vm.isComponentMember &&
                  _vm.isKpmgUser()
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green svg-btn",
                          attrs: {
                            disabled: _vm.chooseable && !!_vm.multiChoose.mode,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toogleMultiSelect("delete")
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "btn-icon",
                            attrs: {
                              src: require("@/assets/img/icon-batchdeletion.svg"),
                              width: "100%",
                            },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("patch_delete")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.activeTab == 1 && _vm.isKpmgUser()
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green svg-btn",
                          attrs: {
                            disabled: _vm.chooseable && !!_vm.multiChoose.mode,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toogleMultiSelect("delete")
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "btn-icon",
                            attrs: {
                              src: require("@/assets/img/icon-batchsetting.svg"),
                              width: "100%",
                            },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("patch_methods")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "wl-search-bar" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "bottom" },
                    },
                    [
                      _c("div", {
                        staticStyle: { width: "590px" },
                        attrs: { slot: "content" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("JOINT_WORKING_ADD_TIPS")),
                        },
                        slot: "content",
                      }),
                      _c(
                        "span",
                        [
                          _vm.isKpmgUser() &&
                          !(_vm.activeTab == "1" && _vm.isComponentMember)
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "wl-green mgr10",
                                  attrs: {
                                    icon: "el-icon-plus",
                                    disabled: !(
                                      _vm.kpRoleBind &&
                                      _vm.kpRoleBind.length > 0
                                    ),
                                  },
                                  on: { click: _vm.toggleAddVisible },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("COMMON_ADD")) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm.isKpmgUser() &&
                  !(_vm.activeTab == "1" && _vm.isComponentMember) &&
                  !(_vm.activeTab == "2")
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          attrs: {
                            disabled: _vm.chooseable && !!_vm.multiChoose.mode,
                            icon: "el-icon-message",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toogleMultiSelect("email")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  `PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${_vm.activeTab}`
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.activeTab === "1" &&
                  !(_vm.activeTab == "1" && _vm.isComponentMember)
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green template-uploader",
                          attrs: { icon: "el-icon-setting" },
                          on: { click: _vm.toggleDuedayAlarmVisible },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SET_DUEDAYALARM")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green svg-btn",
                      attrs: { disabled: !_vm.hasPermission("download") },
                      on: { click: _vm.exportList },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("Export_exchange_Items")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "wl-green svg-btn",
                      attrs: {
                        disabled:
                          !_vm.hasPermission("download") ||
                          (_vm.chooseable && !!_vm.multiChoose.mode),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleMultiSelect("export")
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-export.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("BATCH_export")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                class: [
                  "table-container-wrapper",
                  _vm.chooseable ? "show-table-bottom-operate" : "",
                ],
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "exchangeTable",
                    staticClass: "exchange-table",
                    attrs: {
                      height: "100%",
                      data: _vm.data,
                      border: "",
                      stripe: "",
                    },
                    on: {
                      "select-all": (e) => _vm.handleSelectAll(e, _vm.data),
                      select: _vm.handleSelect,
                    },
                  },
                  [
                    _vm.chooseable
                      ? _c("el-table-column", {
                          attrs: {
                            align: "center",
                            type: "selection",
                            width: "50",
                          },
                        })
                      : _vm._e(),
                    _vm.activeTab != "2"
                      ? _c("el-table-column", {
                          key: 1,
                          attrs: {
                            prop: "entityName",
                            "min-width": "200",
                            "show-overflow-tooltip": "",
                            label: _vm.$t("TABLE_HEAD_EntityList2"),
                          },
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 2,
                      attrs: {
                        prop: "category",
                        "min-width": "150",
                        align: _vm.activeTab === "2" ? "center" : "left",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("TABLE_HEAD_Category")) +
                                      "\n                                    "
                                  ),
                                  _c("MultiSelectPopver", {
                                    attrs: {
                                      hidePopperSearch: _vm.hidePopperSearch,
                                      value: _vm.searchForm.category,
                                      labelKey: "label",
                                      valueKey: "value",
                                      inputFilterKey: ["label", "value"],
                                      options: _vm.categoryOptions,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.searchForm,
                                          "category",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm.activeTab === "1"
                      ? _c("el-table-column", {
                          key: 3,
                          attrs: {
                            prop: "status",
                            width: "200",
                            label: _vm.$t("TABLE_HEADER_EXCHANGE_STATUS"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "TABLE_HEADER_EXCHANGE_STATUS"
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c("MultiSelectPopver", {
                                          attrs: {
                                            hidePopperSearch:
                                              _vm.hidePopperSearch,
                                            value: _vm.searchForm.statusList,
                                            labelKey: "label",
                                            valueKey: "value",
                                            inputFilterKey: ["label", "value"],
                                            options: _vm.statusOptions,
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              return _vm.$set(
                                                _vm.searchForm,
                                                "statusList",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        class:
                                          "group_report_status_" +
                                          scope.row.status,
                                        staticStyle: { position: "relative" },
                                        attrs: {
                                          disabled: _vm.calcStatusCellDisabled(
                                            scope.row
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.statusChange(scope.row)
                                          },
                                        },
                                        model: {
                                          value: scope.row.status,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "status", $$v)
                                          },
                                          expression: "scope.row.status",
                                        },
                                      },
                                      _vm._l(
                                        _vm.statusOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                              disabled:
                                                _vm.calcStatusOptionDisable(
                                                  scope.row,
                                                  item
                                                ),
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            523507508
                          ),
                        })
                      : _vm._e(),
                    _vm.activeTab === "1"
                      ? _c("el-table-column", {
                          key: 4,
                          attrs: { prop: "dueDay", width: "200" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("TABLE_HEADER_DUEDAY")
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom",
                                              trigger: "click",
                                              "visible-arrow": false,
                                            },
                                            on: { hide: _vm.hidePopperSearch },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "reference",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "th-filter-down",
                                                        },
                                                        [
                                                          _c("i", {
                                                            class: [
                                                              "el-icon-arrow-down",
                                                              _vm.searchForm
                                                                .dueDay
                                                                ? "el-icon-arrow-down-active"
                                                                : "",
                                                            ],
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3138397984
                                            ),
                                          },
                                          [
                                            [
                                              _c("el-date-picker", {
                                                staticClass:
                                                  "input-with-select",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "TABLE_HEADER_DUEDAY"
                                                  ),
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                },
                                                model: {
                                                  value: _vm.searchForm.dueDay,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.searchForm,
                                                      "dueDay",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchForm.dueDay",
                                                },
                                              }),
                                            ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled:
                                          _vm.activeTab == "1" &&
                                          _vm.isComponentMember,
                                        "value-format": "yyyy-MM-dd",
                                        type: "date",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.dueDayChange(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.dueDay,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "dueDay", $$v)
                                        },
                                        expression: "scope.row.dueDay",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2656540424
                          ),
                        })
                      : _vm._e(),
                    _vm.activeTab === "1"
                      ? _c("el-table-column", {
                          key: 20,
                          attrs: { prop: "confirmDueDay", width: "200" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "TABLE_HEADER_CONFIRM_DUEDAY"
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom",
                                              trigger: "click",
                                              "visible-arrow": false,
                                            },
                                            on: { hide: _vm.hidePopperSearch },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "reference",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "th-filter-down",
                                                        },
                                                        [
                                                          _c("i", {
                                                            class: [
                                                              "el-icon-arrow-down",
                                                              _vm.searchForm
                                                                .confirmDueDay
                                                                ? "el-icon-arrow-down-active"
                                                                : "",
                                                            ],
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1531943602
                                            ),
                                          },
                                          [
                                            [
                                              _c("el-date-picker", {
                                                staticClass:
                                                  "input-with-select",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "TABLE_HEADER_CONFIRM_DUEDAY"
                                                  ),
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchForm
                                                      .confirmDueDay,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.searchForm,
                                                      "confirmDueDay",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchForm.confirmDueDay",
                                                },
                                              }),
                                            ],
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        "value-format": "yyyy-MM-dd",
                                        type: "date",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.confirmDueDayChange(
                                            scope.row
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row.confirmDueDay,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "confirmDueDay",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.confirmDueDay",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3260737900
                          ),
                        })
                      : _vm._e(),
                    _vm.activeTab === "1"
                      ? _c("el-table-column", {
                          key: 5,
                          attrs: { prop: "chargeName", width: "190" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "header-with-popup" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("TABLE_HEADER_KPUSER")
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c("MultiSelectPopver", {
                                          attrs: {
                                            hidePopperSearch:
                                              _vm.hidePopperSearch,
                                            value:
                                              _vm.searchForm.chargeUserList,
                                            labelKey: "xlabel",
                                            valueKey: "id",
                                            inputFilterKey: ["xlabel", "id"],
                                            options: _vm.kpmgUserList.map(
                                              (v) => ({
                                                xlabel:
                                                  v.userName +
                                                  "(" +
                                                  v.profitCenter +
                                                  ")",
                                                ...v,
                                              })
                                            ),
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              return _vm.$set(
                                                _vm.searchForm,
                                                "chargeUserList",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          filterable: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeKpmgUser(scope.row)
                                          },
                                        },
                                        model: {
                                          value: scope.row.chargeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "chargeName",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.chargeName",
                                        },
                                      },
                                      _vm._l(_vm.kpmgUserList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label:
                                              item.userName +
                                              "(" +
                                              item.profitCenter +
                                              ")",
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3936272748
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      key: 6,
                      attrs: {
                        prop: "fileList",
                        width: _vm.activeTab === "1" ? 125 : 200,
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm.$t("TABLE_HEADER_fileNameList")
                                      ) +
                                      "\n                                    "
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        trigger: "click",
                                        "visible-arrow": false,
                                      },
                                      on: { hide: _vm.hidePopperSearch },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "reference",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "th-filter-down",
                                                },
                                                [
                                                  _c("i", {
                                                    class: [
                                                      "el-icon-arrow-down",
                                                      _vm.searchForm
                                                        .searchContent
                                                        ? "el-icon-arrow-down-active"
                                                        : "",
                                                    ],
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      [
                                        _c("el-input", {
                                          staticClass: "input-with-select",
                                          attrs: {
                                            size: "medium",
                                            placeholder:
                                              _vm.$t("fileNameKeyword"),
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.searchForm.searchContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.searchForm,
                                                "searchContent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchForm.searchContent",
                                          },
                                        }),
                                      ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fileList &&
                              scope.row.fileList.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "file-number-hint",
                                      on: {
                                        click: function ($event) {
                                          return _vm.toogleFileDetailVisible(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(scope.row.fileList.length) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 7,
                      attrs: {
                        align: "center",
                        width: _vm.activeTab === "1" ? 70 : 150,
                        label: _vm.$t("COMMON_UPLOAD"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.isIE
                                ? _c("i", {
                                    class: [
                                      "el-icon-upload",
                                      !_vm.hasPermission("upload") ||
                                      (_vm.activeTab == "1" &&
                                        !["1", "3"].includes(scope.row.status))
                                        ? "wl-icon-messageBoardNull"
                                        : "wl-icon-messageBoard",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleUploadVisible(
                                          scope.row
                                        )
                                      },
                                    },
                                  })
                                : _c(
                                    "el-button",
                                    {
                                      class: [
                                        "el-icon-upload",
                                        !_vm.hasPermission("upload") ||
                                        (_vm.activeTab == "1" &&
                                          !["1", "3"].includes(
                                            scope.row.status
                                          ))
                                          ? "upload-forbid"
                                          : "wl-green",
                                      ],
                                      attrs: {
                                        size: "mini",
                                        disabled:
                                          !_vm.hasPermission("upload") ||
                                          (_vm.activeTab == "1" &&
                                            !["1", "3"].includes(
                                              scope.row.status
                                            )),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toogleUploadVisible(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("COMMON_UPLOAD")))]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      key: 8,
                      attrs: {
                        width: _vm.activeTab === "1" ? 100 : 180,
                        align: "center",
                        label: _vm.$t("TABLE_HEAD_COMMENTS"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "header-with-popup" },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("TABLE_HEAD_COMMENTS")) +
                                      "\n                                    "
                                  ),
                                  _c("DatePickerPopover", {
                                    attrs: {
                                      value: _vm.searchForm.commentDate,
                                      hidePopperSearch: _vm.hidePopperSearch,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.searchForm,
                                          "commentDate",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex item-center justify-center",
                                },
                                [
                                  _c("i", {
                                    class: [
                                      scope.row.messageNum > 0
                                        ? "wl-icon-messageBoard"
                                        : "wl-icon-messageBoardNull",
                                      "el-icon-s-comment",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleMessageBoardVisible(
                                          scope.row
                                        )
                                      },
                                    },
                                  }),
                                  scope.row.todayCommentCount
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "message-today" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.todayCommentCount
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("span", [_vm._v("/")]),
                                      ])
                                    : _vm._e(),
                                  scope.row.messageNum > 0
                                    ? _c("span", [
                                        _vm._v(
                                          " " + _vm._s(scope.row.messageNum)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.isKpmgUser() &&
                    !(_vm.activeTab == "1" && _vm.isComponentMember)
                      ? _c("el-table-column", {
                          key: 9,
                          attrs: {
                            width: _vm.activeTab === "1" ? 90 : 170,
                            align: "center",
                            label: _vm.$t("TABLE_HEADER_Action"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-edit-outline wl-icon-edit",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(scope.row)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-delete wl-icon-delete",
                                        staticStyle: { "margin-left": "10px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(scope.row)
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2636650388
                          ),
                        })
                      : _vm._e(),
                    _vm.activeTab === "1"
                      ? _c("el-table-column", {
                          key: 10,
                          attrs: {
                            width: "125",
                            align: "center",
                            label: _vm.$t("TABLE_HEADER_MODIFY_RECORD"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-document-copy wl-icon-record",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getModifyRecord(scope.row)
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2372039700
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.chooseable
              ? _c(
                  "div",
                  { staticClass: "footer-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        attrs: { disabled: !_vm.chooseable },
                        on: { click: _vm.cancelChoose },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("btn_cancel")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm.chooseable && _vm.multiChoose.mode == "download"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.tooglebatchDownLoad("download")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("COMMON_DOWNLOAD")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isKpmgUser() &&
                    !(_vm.activeTab == "1" && _vm.isComponentMember) &&
                    _vm.chooseable &&
                    _vm.multiChoose.mode == "email"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: { click: _vm.toogleEmailVisible },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    `PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${_vm.activeTab}`
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isKpmgUser() &&
                    !(_vm.activeTab == "1" && _vm.isComponentMember) &&
                    _vm.chooseable &&
                    _vm.multiChoose.mode == "delete"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: { click: _vm.onBatchDelete },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("COMMON_DELETE")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.chooseable && _vm.multiChoose.mode == "export"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: {
                              disabled:
                                _vm.chooseable &&
                                _vm.hasSelectedList.length == 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.tooglebatchDownLoad("export")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("BATCH_export")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.activeTab == "1" && _vm.multiChoose.mode == "delete"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: { disabled: _vm.emailBtnDisabled },
                            on: {
                              click: function ($event) {
                                _vm.openbatchStatusChange(
                                  _vm.$t("EXCHANGE_BATCH_STATUS"),
                                  0
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("EXCHANGE_BATCH_STATUS")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.activeTab == "1" &&
                    !_vm.isComponentMember &&
                    _vm.multiChoose.mode == "delete"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: { disabled: _vm.emailBtnDisabled },
                            on: {
                              click: function ($event) {
                                _vm.openbatchStatusChange(
                                  _vm.$t("EXCHANGE_BATCH_DEADLINE"),
                                  1
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("EXCHANGE_BATCH_DEADLINE")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.activeTab == "1" && _vm.multiChoose.mode == "delete"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "wl-green",
                            attrs: { disabled: _vm.emailBtnDisabled },
                            on: {
                              click: function ($event) {
                                _vm.openbatchStatusChange(
                                  _vm.$t("EXCHANGE_BATCH_KPUSER"),
                                  2
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("EXCHANGE_BATCH_KPUSER")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-pagination",
              {
                staticClass: "wl-pagination",
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-size": _vm.pagination.pageSize,
                  layout: "prev, pager, next, slot, total",
                  total: _vm.pagination.total,
                },
                on: {
                  "current-change": _vm.onCurrentPageChange,
                  "size-change": _vm.onSizeChange,
                },
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "el-select",
                      {
                        on: { change: _vm.onSizeChange },
                        model: {
                          value: _vm.pagination.pageSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.pagination, "pageSize", $$v)
                          },
                          expression: "pagination.pageSize",
                        },
                      },
                      _vm._l(_vm.pageOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c("dashboard", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab !== "2",
            expression: "activeTab !== '2'",
          },
        ],
        ref: "dashboard",
        attrs: {
          dashboardData: _vm.dashboardData,
          pieLoading: _vm.pieLoading,
          dashboardTableLoading: _vm.dashboardTableLoading,
        },
        on: { chooseState: _vm.chooseState, chooseTab: _vm.getPbcDrawerTable },
      }),
      _vm.addVisible
        ? _c("exchange-add", {
            attrs: {
              activeTab: _vm.activeTab,
              saveLoading: _vm.btnLoading,
              initData: _vm.initData,
              onCancel: _vm.toggleAddVisible,
              onAdd: _vm.saveEntityCategory,
            },
          })
        : _vm._e(),
      _vm.addVisibleEmail
        ? _c("exchange-email", {
            attrs: {
              saveLoading: _vm.emailBtnLoading,
              onCancel: _vm.toogleEmailVisible,
              onAdd: _vm.sendEmail,
            },
          })
        : _vm._e(),
      _vm.uploadVisible
        ? _c("upload", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.closeUploadVisble,
              onAdd: _vm.uploadSuccess,
              isComponentMember: _vm.isComponentMember,
            },
          })
        : _vm._e(),
      _vm.messageBoardVisible
        ? _c("messageBoard", {
            attrs: {
              initData: _vm.rowData,
              onCancel: _vm.toogleMessageBoardVisible,
              onAdd: _vm.getTableList,
              siteId: _vm.siteId,
              messageType: _vm.messageType,
            },
          })
        : _vm._e(),
      _vm.fileDetailVisbile
        ? _c("file-detail", {
            attrs: {
              id: _vm.rowData.id,
              tableData: _vm.rowData.fileList,
              curUserName: _vm.curUserName,
              downloadAble: _vm.downloadAble,
              onCancel: _vm.toogleFileDetailVisible,
              isComponentMember: _vm.isComponentMember,
            },
            on: { "on-file-download": _vm.downloadFileDetail },
          })
        : _vm._e(),
      _c("file-confirm-modal", {
        ref: "FileConfirmModal",
        attrs: {
          fileDownloading: _vm.fileDownloading,
          groupList: _vm.hasSelectedList,
          curUserName: _vm.curUserName,
          downloadAble: _vm.downloadAble,
          mode: _vm.downloadDialogMode,
          isComponentMember: _vm.isComponentMember,
        },
        on: {
          ok: _vm.downloadMultipleFiles,
          "on-file-download": _vm.downloadFileDetail,
          updateMultipleSelection: _vm.updateMultipleSelection,
        },
      }),
      _c("entity", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeTab != "2",
            expression: "activeTab != '2'",
          },
        ],
        ref: "entityRef",
        attrs: { onAdd: _vm.onDrawClick, entityData: _vm.entityData },
      }),
      _vm.duedayAlarmVisible
        ? _c("dueday-alarm", {
            attrs: { onCancel: _vm.toggleDuedayAlarmVisible },
          })
        : _vm._e(),
      _vm.recordVisible
        ? _c("modify-record", {
            attrs: {
              statusModifyTable: _vm.statusModifyTable,
              onCancel: _vm.toggleRecordVisible,
            },
          })
        : _vm._e(),
      _vm.batchChangeVisible
        ? _c("batch-change", {
            attrs: {
              title: _vm.batchChangeTitle,
              changeType: _vm.batchChangeElement,
              batchChangeLoading: _vm.batchChangeLoading,
              statusOptions: _vm.statusOptions,
              kpmgUserList: _vm.kpmgUserList,
              "on-cancel": _vm.closeBatchChange,
              onChange: _vm.batchChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }